import { Box, MenuItem, Stack, TextField, Typography } from '@mui/material'
import { useMemo, useState } from 'react'

import { useGetPurchaseReferenceRowsQuery } from '../../store/api/purchaseContractApi'

import PurchaseReferenceGrid from './PurchaseReferenceGrid'
import {
  PURCHASE_REFERENCE_PAGE_CONFIGS,
  PURCHASE_REFERENCE_PAGE_ORDER,
  purchaseReferenceSheetColumnsMode,
  type PurchaseReferencePageKey,
} from './purchaseReferenceConfig'

export default function PurchaseReferencesView() {
  const [pageKey, setPageKey] = useState<PurchaseReferencePageKey>('ValueUpdates')
  const [searchByPage, setSearchByPage] = useState<Partial<Record<PurchaseReferencePageKey, string>>>({})

  const page = PURCHASE_REFERENCE_PAGE_CONFIGS[pageKey]
  const search = searchByPage[pageKey] ?? ''

  const queryArg = useMemo(
    () => ({
      pageKey,
      limit: page.limit ?? 5000,
    }),
    [page.limit, pageKey],
  )

  const { data, isLoading, error, refetch } = useGetPurchaseReferenceRowsQuery(queryArg)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, minHeight: 0, flex: 1 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="wrap"
        gap={1}
        sx={{ px: 0.25 }}
      >
        <Box>
          <Typography variant="h6" fontWeight={700} sx={{ fontSize: '1rem', lineHeight: 1.4 }}>
            Purchase References
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
            Access switchboard parity for the 12 Purchase reference pages.
          </Typography>
        </Box>
        <Stack alignItems="flex-end" spacing={0.5}>
          <TextField
            select
            label="Go to Page:"
            size="small"
            value={pageKey}
            onChange={(e) => setPageKey(e.target.value as PurchaseReferencePageKey)}
            sx={{
              minWidth: 240,
              '& .MuiInputBase-input': { fontSize: '0.8rem' },
              '& .MuiInputLabel-root': { fontSize: '0.8rem' },
            }}
          >
            {PURCHASE_REFERENCE_PAGE_ORDER.map((key) => (
              <MenuItem key={key} value={key}>
                {PURCHASE_REFERENCE_PAGE_CONFIGS[key].label}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </Stack>

      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 }}>
        <PurchaseReferenceGrid
          page={page}
          columnsMode={purchaseReferenceSheetColumnsMode(pageKey)}
          rows={data?.items ?? []}
          search={search}
          onSearchChange={(value) =>
            setSearchByPage((prev) => ({
              ...prev,
              [pageKey]: value,
            }))
          }
          loading={isLoading}
          error={error}
          onRetry={() => {
            void refetch()
          }}
        />
      </Box>
    </Box>
  )
}
